var map = {
	"./5000.png": 109,
	"./500green.png": 110,
	"./500pink.png": 111,
	"./500violet.png": 112,
	"./550blue.png": 113,
	"./600blue.png": 114,
	"./600red.png": 115,
	"./650pink.png": 116,
	"./650violet.png": 117,
	"./700blue.png": 118,
	"./700red.png": 119,
	"./700yellow.png": 120,
	"./800orange.png": 121,
	"./800red.png": 122,
	"./900orange.png": 123,
	"./900pink.png": 124,
	"./900yellow.png": 125,
	"./bankrupt.png": 126,
	"./special.png": 127,
	"./spin_now_arrow.png": 128,
	"./spin_now_arrow_mobile.png": 129,
	"./wedge-LITEGAME-TEMPLATE.png": 130,
	"./wheel-LITEGAME-TEMPLATE(old).png": 131,
	"./wheel-LITEGAME-TEMPLATE.png": 132,
	"./wheel.png": 133
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 365;